// extracted by mini-css-extract-plugin
export default {"wapper":"TextArea_wapper__7qEwJ"};